<ng-container *transloco="let t">
  <mat-card class="mat-elevation-z4">
    <mat-card-title>
      <mat-toolbar class="p-0 no-bg border-bottom-1eee">
        <h2>{{t('activeSessionsCategories.title')}}</h2>
        <span class="fill-remaining-space"></span>
        <a title="{{t('buttons.refresh')}}" (click)="refresh()">
          <mat-icon><i class="material-icons">refresh</i></mat-icon>
        </a>
      </mat-toolbar>
    </mat-card-title>
    <mat-card-content>
      <canvas baseChart [data]="(data$ | async) || []" [labels]="(labels$ | async) || []"
        [chartType]="'pie'" [options]="options" [colors]="(colors$ | async) || []">
      </canvas>
    </mat-card-content>
  </mat-card>
</ng-container>
